export function stringToByteArray(str) {
    if (!str) {
        throw new ReferenceError('Null to Uint8Array conversion is not allowed!');
    }
    const enc = new TextEncoder();
    return enc.encode(str);
}
export function stringToArrayBuffer(str) {
    return stringToByteArray(str).buffer;
}
export function arrayBufferToBase64(buffer) {
    const bufferAsString = arrayBufferToString(buffer);
    return btoa(bufferAsString);
}
export function arrayBufferToString(buffer) {
    return String.fromCharCode.apply(null, Array.from(new Uint8Array(buffer)));
}
export function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
export function base64ToByteArray(base64) {
    return new Uint8Array(base64ToArrayBuffer(base64));
}
export function base64UrlToByteArray(base64Url) {
    const padded = base64Url.length % 4 === 0
        ? base64Url : base64Url + '===='.substring(base64Url.length % 4);
    const base64 = padded.replace(/-/g, '+').replace(/_/g, '/');
    return base64ToByteArray(base64);
}
export function byteArrayToBase64Url(array) {
    const base64 = arrayBufferToBase64(array);
    const base64Url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return base64Url;
}
export function numberToByteArray(num) {
    const encoder = new TextEncoder();
    return encoder.encode(num.toFixed(0));
}
export function enumToByteArray(enumValue) {
    return new Uint8Array([enumValue]);
}
export function combineUrl(base, ...paths) {
    if (base.endsWith('/')) {
        base = base.slice(0, -1);
    }
    paths = paths.map((path) => {
        if (path.startsWith('/')) {
            path = path.substring(1);
        }
        if (path.endsWith('/')) {
            path = path.slice(0, -1);
        }
        return path;
    });
    return `${base}/${paths.join('/')}`;
}
export function arrayBufferToHexString(buffer) {
    return [...new Uint8Array(buffer)]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('');
}
export function combineUint8Arrays(...arrays) {
    const totalSize = arrays.reduce((acc, array) => acc + array.length, 0);
    const combined = new Uint8Array(totalSize);
    arrays.forEach((array, i, arrays) => {
        const offset = arrays.slice(0, i).reduce((acc, array) => acc + array.length, 0);
        combined.set(array, offset);
    });
    return combined;
}
export async function computeVerificationCode(payload) {
    const digest = await crypto.subtle.digest("SHA-256", payload);
    const verificationCode = [...new Uint8Array(digest).subarray(0, 3)]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();
    return `${verificationCode.substring(0, 3)} ${verificationCode.substring(3, 6)}`;
}
export function areEqualUint8Array(a, b) {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; i++) {
        if ((a[i] !== b[i]))
            return false;
    }
    return true;
}
export function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}
export function addDays(date, days) {
    const copy = new Date(date.getTime());
    copy.setDate(date.getDate() + days);
    return copy;
}
export function format(date) {
    return date.toISOString().split('.')[0] + 'Z';
}
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function getUnsafeDateNow() {
    // Vault validation requires that the the addedAt value of each vault entry is
    // always larger than the one before. To ensure that this is the case, we need
    // a monotonically increasing time source. Use MonotonicTimeSource for that!
    //
    // However, for other purposes, such as checking vault validity,
    // system time monotonicity is not required, so we can use the current system time.
    //
    // `new Date()` is disallowed by the linter, so that a conscious decision needs to
    // be made when picking the method to use.
    //
    // Creating vault entry -> MonotonicTimeSource
    // Everything else -> getUnsafeDateNow
    // eslint-disable-next-line no-restricted-syntax
    return new Date();
}
